<template>
    <!-- 学习报告页 -->
    <div class="box">
        <!-- 标题 -->
        <div
            :class="['box-title', titleClass]">
            {{pageData.courseName}}
        </div>

        <img
            v-if="!!pageData.isShowStage"
            class="report-img"
            src="https://g.gsxcdn.com/2320758802_bl5usb6i.png"
            alt=""
            srcset=""
            @click="gotoStage"
        >

        <!-- 用户信息&&成就&&作品 -->
        <div :class="['box-top', !!pageData.isShowStage ? 'mar-53' : '']">
            <!-- 用户信息 -->
            <div class="box-top-user">
                <div class="avatarUrl-box">
                    <img :src="pageData.avatarUrl" class="avatarUrl" alt="" srcset="">
                </div>
                <div class="username">
                    {{pageData.nickname}}
                </div>
            </div>
            <!-- 我的成就 -->
            <div v-if="pageData.achievement" class="box-top-achievement">
                <div class="box-top-achievement-item">
                    <div class="group_5">
                        <span class="font_2">{{pageData.achievement.learnDays}}</span>
                        <span class="font_4">{{achievementDsec[0].unit}}</span>
                    </div>
                    <span class="font_3">{{achievementDsec[0].desc}}</span>
                </div>
                <div class="box-top-achievement-item">
                    <div class="group_5">
                        <span class="font_2">{{pageData.achievement.totalNum}}</span>
                        <span class="font_4">{{achievementDsec[1].unit}}</span>
                    </div>
                    <span class="font_3">{{achievementDsec[1].desc}}</span>
                </div>
                <div class="box-top-achievement-item">
                    <div class="group_5">
                        <span class="font_2">{{pageData.achievement.interactiveNum}}</span>
                        <span class="font_4">{{achievementDsec[2].unit}}</span>
                    </div>
                    <span class="font_3">{{achievementDsec[2].desc}}</span>
                </div>
            </div>
            <!-- 朗读开口秀 -->
            <ReadAloud
                v-if="pageData.opusVideoMix || pageData.opusUrl && showModele"
                :page-data="pageData"
            />
            <!-- 思维导图 -->
            <Mind
                v-if="pageData.courseTypeId === 25 && pageData.opusHistoryInfo && showModele"
                :page-data="pageData"
            />
            <!-- 小小演说家 -->
            <Speech
                v-if="pageData.courseTypeId === 13 || pageData.courseTypeId === 26"
                :page-data="pageData"
                :show-modele="showModele"
            />
            <!-- 我是小侦探 -->
            <PicbookTransfrom
                v-if="pageData.courseTypeId === 30 && pageData.opusDetectiveInfo && pageData.opusDetectiveInfo.opusPicbookUrl"
                :page-data="pageData"
            />
            <!-- 【英语】开口读绘本 -->
            <English
                ref="kkdhb"
                v-if="isEn"
                :page-data="pageData"
                :show-modele="showModele"
                @event-bus="eventBus"
            />
        </div>

        <!-- 读后感受模块 -->
        <Feel
            v-if="pageData.feedbackInfo"
            :page-data="pageData"
            @updatePage="getPageDataApi"
        />

        <!-- 【英语】优秀发音模块 -->
        <Read
            ref="yxfy"
            v-if="isEn"
            :page-data="pageData"
            :show-modele="showModele"
            @event-bus="eventBus"
        />

        <!-- 成语卡片 -->
        <div v-if="pageData.idiomHarvestInfo && pageData.idiomHarvestInfo.idiomCardUrl" class="achievement box-idiomcard">
            <div :class="['title', isEn ? 'title-en' : '']">
                成语卡片
            </div>
            <img
                class="cardimg"
                :src="pageData.idiomHarvestInfo.idiomCardUrl"
            >
        </div>

        <!-- 学习收获 -->
        <div v-if="pageData.otherHarvestInfo">
            <div
                v-for="(item, index) in pageData.otherHarvestInfo"
                :key="index"
                class="achievement box-havest"
            >
                <div :class="['title-pos', 'title', isEn ? 'title-en' : '']">
                    {{item.moduleName}}
                </div>
                <div class="summary-content">
                    <div v-for="(itm, idx) in item.body" :key="idx" class="summary">
                        <div
                            v-if="itm.property === 'Input'"
                            :class="['summary-richtext', isEn ? 'summary-richtext-en' : '']"
                            v-html="itm.content"
                        ></div>
                        <div v-if="itm.property === 'Image'" class="summary-image-box">
                            <img class="summary-image" :src="itm.content" alt="">
                        </div>
                        <div v-if="itm.property === 'Video'" class="summary-video-box">
                            <Myvideo
                                :tag-index="itm.tagIndex"
                                play-img="https://g.gsxcdn.com/2274080577_ggn54um8.png"
                                :page-data="{
                                    opusVideoMix: itm.content
                                }"
                                style="position: absolute;
        top: 1.41rem;
        left: 50%;
        transform: translateX(-50%);
        border-radius: .21rem;
        width: 7.23rem;
        height: 4.05rem;"
                                @stop-other="stopOther"
                            />
                        </div>
                        <img v-show="idx < item.body.length - 1" class="summary-separate" src="https://g.gsxcdn.com/2237609437_32ovzx9x.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部分享 -->
        <div v-if="!isSH && !isWX" class="box-bottom" :style="`height:${isBangScreen ? '2rem' : '1.4rem'}`">
            <div class="share-wechat" @click="shareReportH5(1)">
                分享好友
            </div>
            <div class="share-pyq" @click="shareReportH5(2)">
                晒报告
            </div>
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import Myvideo from '@/components/Myvideo.vue';
import {sendMessageApp, isWXBrower, setUrlQuery} from '@/utils/utils';
import {COURSE_TYPE} from '@/utils/commonConst';
import {getShareDetail} from '@/api/api';
import ReadAloud from './components/ReadAloud.vue';
import Mind from './components/Mind.vue';
import Speech from './components/Speech.vue';
import PicbookTransfrom from './components/PicbookTransfrom.vue';
import Feel from './components/Feel.vue';
import English from './components/English.vue';
import Read from './components/Read.vue';

/**
 * 1-古诗课 29-复习课 13-成语课 25-历史课 26-小古文课 30-表达课 12-拼音课
 * 做伪直播课程也就是之前的复习课，因此不会在进来h5的这个29-复习课了
 * 中教课=36；外教课=37；绘本精讲课—阅读=35；绘本精讲课—英语=38
 */

const MOCK = {
    nickname: '-',
    avatarUrl: 'https://g.gsxcdn.com/feihua/20220607/OKqd_1654592423.png',
    courseName: '-',

    courseTypeId: 13,
    achievement: {
        totalNum: 0,
        learnDays: 2,
        interactiveNum: 2
    },

    hbCoverInfo: {
        coverImageUrl: 'https://g.gsxcdn.com/2233465550_1y4a2egb.jpeg',
        coverAudioUrl: ''
    },
    hbPages: [
        {
            qHbImage: 'https://g.gsxcdn.com/2233465336_ua5bkmw6.jpeg',
            qHbAudio: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
            qHbText: 'small and big'
        },
        {
            qHbImage: 'https://g.gsxcdn.com/2233465550_1y4a2egb.jpeg',
            qHbAudio: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
            qHbText: 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa'
        },
        {
            qHbImage: 'https://g.gsxcdn.com/2233465550_1y4a2egb.jpeg',
            qHbAudio: 'https://p.gsxcdn.com/2239473166_8p7jhvk1.mp3',
            qHbText: 'say small and big'
        }
    ],

    // https://g.gsxcdn.com/feihua/20230414/RRBw_1681468021.mp4
    opusVideoMix: '',
    opusUrl: '',
    opusVideo: '',

    opusInfo: [
        {
            image: 'https://g.gsxcdn.com/2233465336_ua5bkmw6.jpeg',
            url: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
            txt: '画蛇添足',
            voiceResult: '',
            audio: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
            stoneVal: 3,
        },
        {
            image: 'https://g.gsxcdn.com/2233465550_1y4a2egb.jpeg',
            url: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
            txt: 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
            voiceResult: '',
            audio: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
            stoneVal: 3,
        },
        {
            image: 'https://g.gsxcdn.com/2233465550_1y4a2egb.jpeg',
            url: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
            txt: '画蛇添足',
            voiceResult: '',
            audio: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
            stoneVal: 3,
        },
        // {
        //     image: 'https://g.gsxcdn.com/2233465550_1y4a2egb.jpeg',
        //     url: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
        //     txt: '画蛇添足',
        //     voiceResult: '',
        //     audio: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
        //     stoneVal: 3,
        // },
        // {
        //     image: 'https://g.gsxcdn.com/2233465550_1y4a2egb.jpeg',
        //     url: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
        //     txt: '画蛇添足',
        //     voiceResult: '',
        //     audio: 'https://g.gsxcdn.com/feihua/20230613/csVM_1686639818.mp3',
        //     stoneVal: 3,
        // }
    ],

    idiomHarvestInfo: {
        idiomCardUrl: 'https://g.gsxcdn.com/feihua/20220607/OKqd_1654592423.png'
    },

    otherHarvestInfo: [
        {
            moduleName: 'xuexi',
            body: [
                {
                    content: '<ul><li>wwwwwwww</li><li>wwwwwwww</li><li>wwwwwwww</li></ul>',
                    property: 'Input'
                },
                {
                    content: 'Image',
                    property: 'Image'
                },
                {
                    content: 'Image',
                    property: 'Video'
                }
            ]
        },
        {
            moduleName: 'xuexi',
            body: [
                {
                    content: 'Image',
                    property: 'Image'
                }
            ]
        },
        {
            moduleName: 'xuexi',
            body: [
                {
                    content: 'Image',
                    property: 'Video'
                },
                {
                    content: 'Input',
                    property: 'Input'
                },
                {
                    content: 'Image',
                    property: 'Image'
                },
            ]
        }
    ],

    opusDetectiveInfo: {
        opusPicbookUrl: 'https://test-gx.feihua100.com/picbook/demo',
        opusQuestions: [
            {
                questionId: 60125,
                voiceUrl: 'https://p.gsxcdn.com/2239473166_8p7jhvk1.mp3'
            },
            {
                questionId: 60126,
                voiceUrl: 'https://p.gsxcdn.com/2244760549_op704ixu.mp3'
            },
            {
                questionId: 60127,
                voiceUrl: 'https://p.gsxcdn.com/2244760550_vaevsab5.mp3'
            },
            {
                questionId: 60128,
                voiceUrl: 'https://p.gsxcdn.com/2244760547_rv4ihiiq.mp3'
            },
        ]
    },
};

@Options({
    components: {
        ReadAloud,
        Mind,
        Speech,
        PicbookTransfrom,
        Myvideo,
        Feel,
        English,
        Read
    },
    computed: {
        isEn() {
            return this.pageData.courseTypeId >= 36 && this.pageData.courseTypeId <= 38;
        },
        titleClass() {
            return this.isEn
                ? (!this.pageData.isShowStage ? 'title-noreport-en' : 'title-report-en')
                : (!this.pageData.isShowStage ? 'title-noreport' : 'title-report');
        }
    },
    unmounted() {
        window.callbackMap.closePage();
    },
    created() {
        const {query} = this.$route;
        const {id = '1', appId, sh: isSH = 0, isBangScreen = 0, course, appVersion} = query;
        this.isSH = Number(isSH);
        this.isBangScreen = Number(isBangScreen);
        this.getPageDataApi();
        this.isWX = isWXBrower();

        window.callbackMap.closePage = () => {
            const allVideos = document.querySelectorAll('video');
            allVideos && allVideos.forEach(item => {
                item.pause();
            });
            const allAudios = document.querySelectorAll('audio');
            allAudios && allAudios.forEach(item => {
                item.pause();
            });
        };

        window.callbackMap.appDisplayState = state => {
            console.log(`端上调用h5方法appDisplayState，state=${state}`);
            console.log(`String(state)=${String(state)}`);
            if (String(state) === '1') {
                // 前台
                this.showModele = true;
            }
            else {
                this.showModele = false;
                // 区分是绘本，调用一个h5方法
                this.pageData.courseTypeId === 30
                    && this.pageData.opusDetectiveInfo
                    && this.pageData.opusDetectiveInfo.opusPicbookUrl
                    && window.callbackMap.handlePicbookH5(JSON.stringify({
                        type: 'pause'
                    }));
            }
        };
    }
})
export default class StudyReport extends Vue {
    isSH = 0;

    isBangScreen = 0;

    achievementDsec = null;

    pageData = {};

    showModele = true;

    async getPageDataApi() {
        const {query} = this.$route;
        const {id = '1', appId, sh: isSH = 0, course, appVersion} = query;
        const res = await getShareDetail({
            id, appId
        });
        if (res.code === '0') {
            let tagIndex = 1;
            const {otherHarvestInfo} = res.data;
            if (otherHarvestInfo) {
                otherHarvestInfo.forEach(item => {
                    const {body} = item;
                    body.forEach(itm => {
                        if (itm.property === 'Video') {
                            itm.tagIndex = tagIndex++;
                        }
                    });
                });
            }
            this.pageData = res.data;
            // this.pageData = MOCK;
            this.pageData.courseTypeId = Number(this.pageData.courseTypeId);
            const {name, desc} = COURSE_TYPE[this.pageData.courseTypeId || 1];
            this.achievementDsec = desc;
            try {
                window.collectEvent('config', {
                    user_unique_id: this.pageData?.userId
                });
                window.collectEvent('yd_course_browse_study_report', {
                    course: `${this.pageData.courseName}${name}`
                });
            }
            catch (error) {
                console.error('上报错误');
                console.log(error.message);
            }
        }
    }

    stopOther() {
        // 处理其他语音暂停播放

    }

    eventBus(res) {
        // 有新的模块要播放语音了，那么重置当前播放的语音
        switch (res) {
            case 'yxfy':
                this.$refs.kkdhb.resetAll();
                break;
            case 'kkdhb':
                this.$refs.yxfy.resetAll();
                break;
            default:
                break;
        }
    }

    // 去结营报告页面
    gotoStage() {
        // 通过端能力跳转新的结营报告页面，
        sendMessageApp('jumpPage', JSON.stringify({
            jumpType: 3,
            isLandscape: false,
            // 原页面是否为竖屏
            needPortraitWhenDisappear: true,
            h5Url: setUrlQuery({
                url: `${window.location.protocol}//${window.location.host}/studyReport/campReport`,
                query: {
                    id: this.$route.query.id,
                    cTableId: this.pageData.cTableId
                }
            }),
            isCloseCurPage: true,
            isUseNativeNav: false
        }));
    }

    /**
     * 晒报告
     * type: 1发送好友；2分享朋友圈；
     */
    shareReportH5(type) {
        // 点击分享上报标签
        const params = {
            type,
            shareInfo: this.pageData.shareInfo,
            shareBack: 'shareBack',
            posterType: 1
        };
        const str = JSON.stringify(params);
        console.log('shareReport', str);
        sendMessageApp('shareReport', str);
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 100%;
    min-height: 100vh;
    background: #F3F5F6;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-bottom: 3.52rem;

    // 作品名称
    &-title {
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: .93rem;
        box-sizing: border-box;
        font-size: .51rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
    }

    .title-noreport {
        height: 5.65rem;
        background: url("https://i.gsxcdn.com/2586777470_45iewtrs.png") 0 0 no-repeat;
        background-size: cover;
    }

    .title-report {
        height: 7.98rem;
        background: url("https://i.gsxcdn.com/2320793068_qu3d9kae.png") 0 0 no-repeat;
        background-size: cover;
    }

    .title-noreport-en {
        height: 5.65rem;
        background: url("https://i.gsxcdn.com/2606554202_8yvyfgwr.png") 0 0 no-repeat;
        background-size: cover;
    }

    .title-report-en {
        height: 7.98rem;
        background: url("https://i.gsxcdn.com/2586776781_5h6xssut.png") 0 0 no-repeat;
        background-size: cover;
    }

    .report-img {
        width: 9.68rem;
        height: 3.73rem;
        margin-top: -6.1rem;
    }

    .mar-53 {
        margin-top: .53rem !important;
    }

    // 用户信息&&成就&&作品
    &-top {
        padding-bottom: .5rem;
        margin-top: -2.6rem;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 9.15rem;
        background: #FFFFFF;
        box-shadow: 0 .05rem .16rem 0 rgba(229, 228, 228, .4);
        border-radius: .43rem;

        // 用户信息
        &-user {
            width: 100%;
            box-sizing: border-box;
            display: flex;
            padding-left: .51rem;

            .avatarUrl-box {
                margin-top: -.53rem;
                width: 1.97rem;
                height: 1.97rem;
                background: url("https://g.gsxcdn.com/2233022243_qy7lxy1c.png") 0 0 no-repeat;
                background-size: cover;
                display: flex;
                align-items: center;
                justify-content: center;

                .avatarUrl {
                    width: 1.5rem;
                    height: 1.5rem;
                    border-radius: 50%;
                }
            }

            .username {
                margin-top: .45rem;
                margin-left: .08rem;
                font-size: .4rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #333333;
            }
        }

        // 成就
        &-achievement {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-bottom: .85rem;

            &-item {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;

                .group_5 {

                    .font_2 {
                        font-size: .85rem;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        color: #FF781E;
                        line-height: 1.07rem;
                        letter-spacing: .007rem;
                        margin-right: 0.05rem;
                    }

                    .font_4 {
                        font-size: .32rem;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        color: #0B0B0B;
                        line-height: .43rem;
                    }
                }

                .font_3 {
                    font-size: .32rem;
                    font-family: PingFangSC, PingFang SC;
                    color: #333333;
                    margin-top: .2rem;
                    font-weight: 500;
                }
            }
        }
    }

    .achievement {
        margin-top: 1.16rem;
        padding-bottom: .6rem;
        width: 9.15rem;
        background: #FFFFFF;
        box-shadow: 0 .05rem .21rem 0 rgba(229, 228, 228, .4);
        border-radius: .43rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    // 学习收获
    &-havest {
        .title-pos {
            position: relative;
            z-index: 1;
        }

        .summary-content {
            margin-top: .1rem;
            .summary {
                .summary-richtext {
                    padding: 0 .53rem;
                    font-size: .4rem;
                    text-align: left;

                    /deep/li {
                        position: relative;
                        margin-left: .5rem;
                        margin-bottom: .37rem;
                        font-size: .4rem;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        color: #182535;
                        line-height: .51rem;

                        &::before {
                            content: "";
                            display: inline-block;
                            width: .32rem;
                            height: .32rem;
                            background: url("https://g.gsxcdn.com/2274068332_1uayfurm.png") 0 0 no-repeat;
                            background-size: 100% 100%;
                            position: absolute;
                            top: .1rem;
                            left: -.5rem;
                        }
                    }
                }

                .summary-richtext-en {
                    /deep/li {
                        &::before {
                            content: "";
                            display: inline-block;
                            width: .32rem;
                            height: .32rem;
                            background: url("https://g.gsxcdn.com/2590081734_i2t49qf7.png") 0 0 no-repeat;
                            background-size: 100% 100%;
                            position: absolute;
                            top: .1rem;
                            left: -.5rem;
                        }
                    }
                }

                // [1.9.0]内容模块配置中，图片去掉边框，等比缩放、宽度撑满、高度自适应(新样式)
                .summary-image-box {
                    position: relative;
                    left: 50%;
                    margin-left: -4.04rem;
                    width: 8.08rem;
                    background: #FFE4A9;
                    border-radius: 0.43rem;
                    .summary-image {
                        padding: 0rem;
                        border : 0;
                        vertical-align : bottom;
                        margin: 0.27rem;
                        width: 7.55rem;
                        border-radius: 0.32rem;
                    }
                }

                .summary-video-box {
                    padding: 0 .37rem;
                    width: 8.4rem;
                    height: 6.4rem;
                    background-image: url("https://g.gsxcdn.com/2274076495_y8ng2wwf.png");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    background-origin: content-box;
                    position: relative;
                }

                .summary-separate {
                    margin: .4rem .53rem .69rem;
                    width: 8.05rem;
                    height: .05rem;
                    display: block;
                }
            }
        }
    }

    // 成语卡片
    &-idiomcard {
        .cardimg {
            width: 7.89rem;
        }
    }

    .title {
        margin-top: -.28rem;
        margin-bottom: .51rem;
        display: flex;
        padding-top: .22rem;
        justify-content: center;
        font-size: .45rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        width: 4.53rem;
        height: 1.07rem;
        background: url('https://g.gsxcdn.com/2274041109_l17ijy0d.png') 0 no-repeat;
        background-size: cover;
        box-sizing: border-box;
    }

    .title-en {
        background: url('https://g.gsxcdn.com/2586791245_y04k2lo8.png') 0 no-repeat;
        background-size: cover;
    }

    // 底部分享
    &-bottom {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #FFFFFF;
        border-radius: .37rem .37rem 0 0;
        display: flex;
        justify-content: space-between;
        padding: .3rem .42rem;
        z-index: 2;

        .share-wechat {
            width: 4.43rem;
            height: 1.28rem;
            border-radius: .69rem;
            border: 0.03rem solid #FC980F;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: .45rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #FC980F;
        }

        .share-pyq {
            width: 4.37rem;
            height: 1.28rem;
            background: #FC980F;
            border-radius: .64rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: .45rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
        }
    }
}
</style>
